import React, { Fragment } from 'react';
import man from '../../../assets/images/dashboard/max.jpg'
import { Link } from 'react-router-dom';
import { Edit } from 'react-feather';

const UserPanel = () => {
    const url= 'https://image.flaticon.com/icons/png/512/194/194938.png';

    return (
        <Fragment>
            <div className="sidebar-user text-center">
                <div>
                    <img className="img-60 rounded-circle lazyloaded blur-up" src={url ? url : man} alt="#" />
                    <div className="profile-edit">
	    <Link to={`${process.env.PUBLIC_URL}/users/userEdit`}>
                            <Edit />
                        </Link>
                    </div>
                </div>
                <h6 className="mt-3 f-14">ИМЯ</h6>
                <p>главный менеджер</p>
            </div>
        </Fragment>
    );
};

export default UserPanel;
